import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { authApi } from "../lib/api";
import AdminDashboard from "../components/AdminDashboard";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Admin() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [status, setStatus] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) return;
    authApi
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        setStatus("ok");
      })
      .catch(() => setStatus("guest"));
  }, [location.state]);

  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await authApi.post("/auth/logout");
    } catch {}
    setUser(null);
    setStatus("guest");
  };

  if (status === "checking")
    return (
      <main className="min-h-[70vh] flex items-center justify-center" data-testid="admin-loading">
        <div className="w-12 h-12 rounded-full border-2 border-[#ccff00] border-t-transparent animate-spin" />
      </main>
    );

  if (status === "guest")
    return (
      <main className="min-h-[70vh] flex items-center justify-center px-6" data-testid="admin-login-page">
        <div className="bg-[#0f0f10] border border-[#2a2a2a] rounded-md p-12 max-w-md w-full text-center">
          <ShieldCheck className="mx-auto text-[#ccff00] mb-6" size={48} />
          <h1 className="font-display uppercase text-3xl tracking-tight mb-3">Admin Access</h1>
          <p className="text-white/60 mb-8">Sign in with Google to manage courts, coaches and club settings.</p>
          <button
            onClick={login}
            data-testid="admin-google-login-btn"
            className="w-full bg-[#ccff00] text-black font-bold uppercase tracking-wider py-4 rounded-full hover:bg-[#a3e635] hover:-translate-y-0.5 transition-transform duration-200"
          >
            Sign in with Google
          </button>
        </div>
      </main>
    );

  if (!user.is_admin)
    return (
      <main className="min-h-[70vh] flex items-center justify-center px-6" data-testid="admin-unauthorized">
        <div className="bg-[#0f0f10] border border-[#2a2a2a] rounded-md p-12 max-w-md w-full text-center">
          <h1 className="font-display uppercase text-3xl tracking-tight mb-3">Not Authorized</h1>
          <p className="text-white/60 mb-8">
            You're signed in as <span className="text-white">{user.email}</span>, but this area is reserved for club admins.
          </p>
          <button
            onClick={logout}
            data-testid="admin-logout-btn"
            className="border border-white/25 text-white uppercase tracking-wider font-semibold px-8 py-3 rounded-full hover:border-[#ccff00]/70 hover:text-[#ccff00] transition-colors inline-flex items-center gap-2"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </main>
    );

  return <AdminDashboard user={user} onLogout={logout} />;
}
